import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AutoComplete, AutoCompleteUpdate } from "@/model";
import autocompleteRepository from "@/repository/autoCompleteRepository";
import { autocompleteQueryKeys } from "./keys";


export const useUpdateAutocomplete = (agentId: number) => {
    const queryClient = useQueryClient();

    return useMutation<AutoComplete, AxiosError, AutoCompleteUpdate>({
        mutationKey: [agentId, 'autocomplete', 'update'],
        mutationFn: async (body: AutoCompleteUpdate) => {
            try {
                const { data } = await autocompleteRepository.update(agentId, body.autocomplete_id, body);
                return data;
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: autocompleteQueryKeys.pageAll(agentId)
            });
        }
    });
};
